/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewcolumnvisits3Inputs */

const en_sharereviewcolumnvisits3 = /** @type {(inputs: Sharereviewcolumnvisits3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visits`)
};

const de_sharereviewcolumnvisits3 = /** @type {(inputs: Sharereviewcolumnvisits3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besuche`)
};

/**
* | output |
* | --- |
* | "Visits" |
*
* @param {Sharereviewcolumnvisits3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewcolumnvisits3 = /** @type {((inputs?: Sharereviewcolumnvisits3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewcolumnvisits3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewcolumnvisits3(inputs)
	return de_sharereviewcolumnvisits3(inputs)
});
export { sharereviewcolumnvisits3 as "shareReviewColumnVisits" }